module.exports = __webpack_public_path__ + "static/seo-xellardoor-c59db0878f87790b4538d0579fc2dc44.png";